import React, {
  useEffect,
  useState,
} from 'react';
import { DateTime } from 'luxon';

import getColDurationAsMs from './utils/getColDurationAsMs';
import addColDurations from './utils/addColDurations';
import colDiff from './utils/colDiff';

const GanttBars = ({
  colSize,
  colCount,
  colOffset,
  dateMode,
  barOptions,
  barData,
  setBarData,
}) => {
  const [barElements, setBarElements] = useState([]);
  
  useEffect(() => {
    const { barHeight } = barOptions;
    const barTop = (colSize - barHeight) / 2;
  
    const colMs = getColDurationAsMs(dateMode);
    
    const now = DateTime.local();
    const offsetStart = addColDurations(now, dateMode, colOffset);
    
    const bars = barData.map((bar, i) => {
      const colStart = colDiff(bar.start, offsetStart, dateMode, colSize);
      const colEnd = colDiff(bar.end, offsetStart, dateMode, colSize);
      
      const colWidth = colEnd - colStart;
      
      return (
        <rect
          key={`${i}`}
          data-index={`${i}`}
          x={colStart}
          y={barTop + (i * colSize)}
          width={colWidth}
          height={barHeight}
          rx={3}
          ry={3}
          fill="#ddd"
        />
      );
    });
  
    setBarElements(bars);
  }, [barData, colOffset, dateMode]);
  
  return (
    <svg
      style={{position: 'absolute'}}
      width={colSize * colCount}
      y={colSize * 2}
    >
      {barElements}
    </svg>
  );
};

export default GanttBars;
